import React from 'react';
import { useArgoContext } from '@amzn/awsscm-argo-core';
import { ApolloProvider } from '@apollo/react-hooks';
import getApolloClient from './gql';
import Pages from './pages';
import {StoreProvider} from "./common/redux/store/StoreProvider";

export default function App() {
    const context = useArgoContext();

    return (
        // Adding an Apollo provider high in the component tree makes it available for all children to access.
        // See https://www.apollographql.com/docs/react/get-started/ for more info.
        <StoreProvider>
            <ApolloProvider client={getApolloClient(context)}>
                <Pages/>
            </ApolloProvider>
        </StoreProvider>
    );
}

document.body.classList.add('awsui-visual-refresh');
